import $ from "jquery"; // Import jQuery
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const CreateOtherOvertime = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [staff, setStaff] = useState();
  const [distributor, setDistributor] = useState({});
  const [sr, setSr] = useState({});
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [overtimeData, setOvertimeData] = useState([]);

  useEffect(() => {
    fetchInitialData();
    getCurrentDateInput();
    $("body").toggleClass("show-left");
  }, []);

  // Add useEffect to watch for date changes and refresh overtime data automatically
  useEffect(() => {
    if (inputs.date && overtimeData.length > 0) {
      refreshOvertimeDataForDateChange();
    }
  }, [inputs.date]);

  const refreshOvertimeDataForDateChange = async () => {
    setItemLoading(true);

    try {
      // Create array to store updated overtime data
      const updatedOvertimeData = [];

      // Loop through existing overtime data and fetch fresh data for each staff member
      for (const existingEntry of overtimeData) {
        try {
          const response = await Http.get(
            `get-others-overtime-data/${existingEntry.staff_id}?date=${inputs.date}`
          );
          const freshStaffData = response.data;

          if (freshStaffData) {
            // Update the existing entry with fresh data while preserving user inputs
            const updatedEntry = {
              ...existingEntry,
              date: inputs.date,
              card_no: freshStaffData.card_no,
              total_working_hours:
                freshStaffData.total_working_hours ||
                existingEntry.total_working_hours,
              per_hour_salary:
                freshStaffData.per_hour_salary || existingEntry.per_hour_salary,
              // Recalculate total amount based on existing ot_hours and new rate
              total_overtime_amount: (
                parseFloat(existingEntry.ot_hours || 0) *
                parseFloat(
                  freshStaffData.per_hour_salary ||
                    existingEntry.per_hour_salary ||
                    0
                )
              ).toFixed(2),
            };
            updatedOvertimeData.push(updatedEntry);
          } else {
            // If staff data not found for new date, keep existing but update date
            updatedOvertimeData.push({
              ...existingEntry,
              date: inputs.date,
            });
          }
        } catch (error) {
          console.error(
            `Error fetching data for staff ${existingEntry.staff_id}:`,
            error
          );
          // Keep existing data if API fails
          updatedOvertimeData.push({
            ...existingEntry,
            date: inputs.date,
          });
        }
      }

      setOvertimeData(updatedOvertimeData);
    } catch (error) {
      console.error("Error refreshing overtime data:", error);
    } finally {
      setItemLoading(false);
    }
  };

  console.log(overtimeData,'overtimeData')

  const handleOvertimeDataChange = (index, field, value) => {
    const updatedData = [...overtimeData];
    updatedData[index] = { ...updatedData[index], [field]: value };

    // Calculate total amount when hours changed (using per_hour_salary as rate)
    if (field === "ot_hours") {
      const rate = parseFloat(updatedData[index].per_hour_salary || 0);
      const hours = parseFloat(value || 0);
      updatedData[index].total_overtime_amount = (rate * hours).toFixed(2);
    }

    // Also recalculate if rate is manually changed
    if (field === "per_hour_salary") {
      const hours = parseFloat(updatedData[index].ot_hours || 0);
      const rate = parseFloat(value || 0);
      updatedData[index].total_overtime_amount = (rate * hours).toFixed(2);
    }

    setOvertimeData(updatedData);
  };

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      // Simulate API calls with dummy data
      setTimeout(async () => {
        setDistributor({
          id: 1,
          name: "Main Office",
          business_type: "ho",
        });

        setInputs((values) => ({
          ...values,
          invoice_no: "OT-2024-001",
        }));

        // Get others overtime data
        const response = await Http.get("staff");
        setStaff(response.data);
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const addMoreList = async (staffId) => {
    setItemLoading(true);
    try {
      // Check if staff member is already in overtime data BEFORE making API call
      const existingEntry = overtimeData.find(
        (entry) => entry.staff_id === staffId
      );

      if (existingEntry) {
        Swal.fire(
          "Warning!",
          "This staff member is already in the overtime list!",
          "warning"
        );
        setItemLoading(false);
        return;
      }

      // Get staff data from API with current date
      const response = await Http.get(
        `get-others-overtime-data/${staffId}?date=${
          inputs.date || new Date().toISOString().split("T")[0]
        }`
      );

      const selectedStaff = response.data;

      if (!selectedStaff) {
        Swal.fire("Error!", "Staff member not found!", "error");
        setItemLoading(false);
        return;
      }

      // Create new overtime entry with proper data mapping
      const newOvertimeEntry = {
        id: Date.now(), // Generate unique ID for the overtime entry
        staff_id: staffId, // This will be mapped to hr_staff_basic_info_id
        name: selectedStaff.name,
        date: inputs.date || new Date().toISOString().split("T")[0],
        total_working_hours: selectedStaff.total_working_hours || "8.00",
        per_hour_salary: selectedStaff.per_hour_salary || "0.00", // This becomes 'rate'
        ot_hours: "0.00", // This becomes 'total_hours'
        total_overtime_amount: "0.00", // This becomes 'total_amount'
        remarks: "", // Empty remarks
      };

      // Add to overtime data
      setOvertimeData((prev) => [...prev, newOvertimeEntry]);
    } catch (error) {
      console.error("Error adding staff to overtime:", error);
      Swal.fire(
        "Error!",
        error.response?.data?.message || "Failed to add staff to overtime",
        "error"
      );
    } finally {
      setItemLoading(false);
    }
  };

  const removeOvertimeEntry = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedOvertimeData = overtimeData.filter((_, i) => i !== index);
        setOvertimeData(updatedOvertimeData);
        Swal.fire(
          "Removed!",
          "Staff member has been removed from overtime list.",
          "success"
        );
      }
    });
  };

  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedList = list.filter((_, i) => i !== index);
        setList(updatedList);
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  const calculateDueAmount = (finalPrice) => {
    const previous_due = inputs.previous_due
      ? parseFloat(inputs.previous_due)
      : 0;
    const received_amount = inputs.received_amount
      ? parseFloat(inputs.received_amount)
      : 0;

    return finalPrice + previous_due - received_amount;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const selectHandleChange = async (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    const { value } = selectedOption;

    setInputs((values) => ({ ...values, [name]: value }));

    // Simulate API call for distributor data
    setTimeout(() => {
      const listInfo = [
        { id: 1, name: "SR User 1" },
        { id: 2, name: "SR User 2" },
        { id: 3, name: "SR User 3" },
      ];
      setSr(listInfo);
    }, 500);
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    const shortDate = `${year}-${month}-${day}`;
    setInputs((values) => ({ ...values, ["date"]: shortDate }));
  };

  const getCurrentTimeInput = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;
    setInputs((values) => ({ ...values, ["time"]: formattedTime }));
  };

  const formSubmit = () => {
    // Validate that at least one staff member is added
    if (overtimeData.length === 0) {
      Swal.fire(
        "Warning!",
        "Please add at least one staff member for overtime!",
        "warning"
      );
      return;
    }

    // Validate overtime data
    const invalidEntries = overtimeData.filter(
      (entry) => !entry.ot_hours || parseFloat(entry.ot_hours) <= 0
    );

    if (invalidEntries.length > 0) {
      Swal.fire(
        "Warning!",
        "Please fill in valid overtime hours and rates for all staff members!",
        "warning"
      );
      return;
    }

    // Prepare data for submission
    const submissionData = {
      ...inputs,
      overtime_data: overtimeData,
      total_overtime_amount: overtimeData
        .reduce((sum, entry) => sum + parseFloat(entry.total_amount || 0), 0)
        .toFixed(2),
    };

    const submitData = {
      overtime_entries: submissionData?.overtime_data?.map((item) => ({
        hr_staff_basic_info_id: item.staff_id,
        date: inputs.date,
        rate: item.per_hour_salary,
        total_hours: item.ot_hours,
        total_amount: item.total_overtime_amount,
        remarks: item.remarks,
      })),
    };

    setLoading(true);

    Http.post("/transaction", submitData)
      .then((res) => {
        console.log(res, "response");
        navigate("/other-overtime", {
          state: {
            message: res.data.message,
            type: res.data.type || "success",
          },
        });
      })
      .catch((error) => {
        console.error("Submit error:", error);
        setError(
          error.response?.data?.errors || {
            general: "Error creating overtime entries",
          }
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  const cols = [
    {
      field: "card_no",
      header: "Code",
    },
    {
      field: "name",
      header: "Staff Name",
    },
  ];

  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
          disabled={itemLoading}
        >
          {itemLoading ? (
            <i className="fa fa-spinner fa-spin"></i>
          ) : (
            <i className="fa fa-plus"></i>
          )}
        </button>
      </td>
    );
  };

  // Calculate total overtime amount
  const totalOvertimeAmount = overtimeData.reduce(
    (sum, entry) => sum + parseFloat(entry.total_amount || 0),
    0
  );

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Other Overtime</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-8">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Create Other Overtime Form
            </h6>
            <hr></hr>

            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg-4">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                    />
                    {displayError("date")}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Staff Overtime Details{" "}
                        <i className="fa fa-star required"></i>
                      </h5>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                          <thead className="table-dark">
                            <tr>
                              <th>Staff Name</th>
                              <th>Per Hour</th>
                              <th>Ot Hours</th>
                              <th>Total Amount</th>
                              <th>Remarks</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {overtimeData.length === 0 ? (
                              <tr>
                                <td
                                  colSpan="9"
                                  className="text-center text-muted py-4"
                                >
                                  <i className="fa fa-info-circle mb-2"></i>
                                  <br />
                                  No staff members added for overtime yet.
                                  <br />
                                  Use the &quot;+&quot; button from the Available Items
                                  section to add staff members.
                                </td>
                              </tr>
                            ) : (
                              overtimeData.map((staffMember, index) => (
                                <tr key={staffMember.id}>
                                  <td>
                                    <strong>{staffMember.name} <br/> ID: {staffMember.card_no}</strong>
                                    <br />
                                  </td>
                                  <td>
                                    <span className="text-muted">
                                      ৳
                                      {parseFloat(
                                        staffMember.per_hour_salary || 0
                                      ).toFixed(2)}
                                    </span>
                                  </td>
                                  <input
                                    type="hidden"
                                    step="0.25"
                                    className="form-control form-control-sm"
                                    value={
                                      staffMember.total_working_hours || ""
                                    }
                                    onChange={(e) =>
                                      handleOvertimeDataChange(
                                        index,
                                        "total_working_hour",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Working Hours"
                                  />
                                  <td>
                                    <input
                                      type="number"
                                      step="0.25"
                                      className="form-control form-control-sm"
                                      value={staffMember.ot_hours || ""}
                                      onChange={(e) =>
                                        handleOvertimeDataChange(
                                          index,
                                          "ot_hours",
                                          e.target.value
                                        )
                                      }
                                      placeholder="OT Hours"
                                    />
                                  </td>
                                  <td>
                                    <div className="input-group input-group-sm">
                                      <div className="input-group-prepend">
                                        <span className="input-group-text">
                                          ৳
                                        </span>
                                      </div>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={
                                          staffMember.total_overtime_amount ||
                                          "0"
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <textarea
                                      className="form-control form-control-sm"
                                      rows="2"
                                      value={staffMember.remarks || ""}
                                      onChange={(e) =>
                                        handleOvertimeDataChange(
                                          index,
                                          "remarks",
                                          e.target.value
                                        )
                                      }
                                      placeholder="Remarks"
                                    />
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() => removeOvertimeEntry(index)}
                                      title="Remove from overtime list"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                      disabled={loading || itemLoading}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create Overtime
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          <div
            className="card pd-20 pd-sm-40 col-3"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Available Staff Members
            </h6>
            <hr></hr>
            <ReactDataTable
              cols={cols}
              receiveData={staff}
              isLoading={loading}
              actionTemplate={actionTemplate}
              disableCSV={true}
              disablePDF={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateOtherOvertime;
